module.exports = __webpack_public_path__ + "static/email-template-password-reset-light-a9ea8cd451a1903688e8140f49bf864b.png";